import {copyText} from '@github-ui/copy-to-clipboard'
import {CopilotIcon, CopyIcon, TerminalIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Tooltip} from '@primer/react'
import {useCallback, useMemo} from 'react'

type CodingAssistantButtonProps = {
  url: string
  buttonLabel: string
  promptBuilder: (issueUrl: string) => string
  showButtonText?: boolean
}

function buildVSCodeAgentUrl(prompt: string): string {
  const doubleEncoded = encodeURIComponent(encodeURIComponent(prompt))
  return `vscode://github.copilot-chat?mode=agent&prompt=${doubleEncoded}`
}

export function CodingAssistantButton({
  url,
  buttonLabel,
  promptBuilder,
  showButtonText = false,
}: CodingAssistantButtonProps) {
  const prompt = useMemo(() => promptBuilder(url), [promptBuilder, url])
  const vsCodeUrl = useMemo(() => buildVSCodeAgentUrl(prompt), [prompt])

  const handleCopyAsPrompt = useCallback(() => {
    void copyText(prompt)
  }, [prompt])

  const handleOpenInVSCode = useCallback(() => {
    window.open(vsCodeUrl, '_self')
  }, [vsCodeUrl])

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        {showButtonText ? (
          <ActionMenu.Button aria-label={buttonLabel} leadingVisual={TerminalIcon} size="medium">
            {buttonLabel}
          </ActionMenu.Button>
        ) : (
          <Tooltip text={buttonLabel} type="description">
            <ActionMenu.Button aria-label={buttonLabel} leadingVisual={TerminalIcon} size="medium" />
          </Tooltip>
        )}
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.Item onSelect={handleCopyAsPrompt}>
            <ActionList.LeadingVisual>
              <CopyIcon />
            </ActionList.LeadingVisual>
            Copy as prompt
          </ActionList.Item>
          <ActionList.Item onSelect={handleOpenInVSCode}>
            <ActionList.LeadingVisual>
              <CopilotIcon />
            </ActionList.LeadingVisual>
            Copilot for VS Code
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
